/**
 * Wie mag wat in Mass Messages (05-10-2026, Jordy).
 *
 * Volgt precies de server (`src/api/routes/admin_conversations.py`:
 * `_mag_massa_pagina`, `_can_mass_dm`, `_vereis_testdoelgroep_recht`; de
 * schuiven in `src/api/massa_rechten.py`). Bij een wijziging daar hoort er
 * ook een hier.
 *
 * - owner/admin: altijd de hele pagina, Dashboard Mass Message én Platform
 *   Mass DM, en "Test accounts only".
 * - manager: hetzelfde, maar alleen met de schuif "Mass Messages page"
 *   (`mass_messages_page`), ook voor Mass DM via Chats; nooit "Test accounts only".
 * - chatter (en viewer): nooit de pagina. Alleen Mass DM via Chats, alleen
 *   Platform Mass DM, en alleen met de schuif "Mass DM via Chats"
 *   (`mass_dm_native`).
 * - 07-10-2026 (Jordy, bewust anders): een chatter MET de schuif "Mass
 *   Messages page" krijgt wat een manager met die schuif krijgt, maar de
 *   server toont hem alleen zijn toegewezen modellen en echte fans. Een
 *   viewer nooit.
 *
 * De schuiven zet alleen een owner (Settings → gebruiker bewerken); de schuif
 * "Mass Messages page" sinds 07-10-2026 ook een admin.
 */
import type { Mij } from './rechten'

export const MASSA_PAGINA = 'mass_messages_page'
export const MASS_DM_CHATS = 'mass_dm_native'

function rol(mij: Mij | null | undefined): string {
  return String(mij?.role ?? '').toLowerCase()
}

function heeft(mij: Mij, token: string): boolean {
  return (mij.allowed_pages ?? []).includes(token)
}

/** Owner of admin: alles, ook "Test accounts only". */
export function isMassaAdmin(mij: Mij | null | undefined): boolean {
  const r = rol(mij)
  return r === 'owner' || r === 'admin'
}

/** De Mass Messages-pagina (menu, route, alle tabbladen). */
export function magMassaPagina(mij: Mij | null | undefined): boolean {
  if (!mij) return false
  if (isMassaAdmin(mij)) return true
  const r = rol(mij)
  return (r === 'manager' || r === 'chatter') && heeft(mij, MASSA_PAGINA)
}

/** Mag Mass DM, met deze methode of (zonder methode) met één van beide? */
export function magMassDm(mij: Mij | null | undefined, methode?: 'direct' | 'native'): boolean {
  if (!mij) return false
  const r = rol(mij)
  if (r === 'owner' || r === 'admin') return true
  if (r === 'manager') return magMassaPagina(mij)
  if (r !== 'chatter' && r !== 'viewer') return false
  // 07-10-2026 (Jordy): chatter met de paginaschuif zoals een manager.
  if (r === 'chatter' && magMassaPagina(mij)) return true
  if (methode === 'direct') return false
  if (heeft(mij, 'panel_deny_mass_dm')) return false
  return heeft(mij, MASS_DM_CHATS)
}

/** De doelgroep "Test accounts only": alleen owner en admin. */
export function magTestDoelgroep(mij: Mij | null | undefined): boolean {
  return isMassaAdmin(mij)
}

/** Alleen een owner zet de schuiven (de server weigert anderen met 403). */
export function magSchuivenZetten(mij: Mij | null | undefined): boolean {
  return rol(mij) === 'owner'
}

/** De schuif "Mass Messages page": owner én admin (07-10-2026, Jordy). */
export function magPaginaSchuifZetten(mij: Mij | null | undefined): boolean {
  return isMassaAdmin(mij)
}
